import { Node } from "@jsplumbtoolkit/core";
import { filterClasses } from "@swivl-mono/helpers";

import NodeModel from "../../Nodes/NodeModel";
import "./InspectorPanel.scss";

interface Props {
  canEdit: boolean;
  selectedNode?: Node;
  updateNode(node: Node, originalNode?: Node, forceRedraw?: boolean): void;
  deleteNodes(nodeOrNodes: Node | Node[]): void;
  duplicateNode?(nodeId: string): void;
}
export function InspectorPanel(props: Props) {
  const { canEdit, duplicateNode } = props;
  // const intents = NLPModel.useState((s)=> s.intents)

  const { selectedNode, updateNode, deleteNodes } = props;
  const node: any = selectedNode?.data;
  if (!node) {
    return null;
  }

  let model = NodeModel.forType(node.type);
  if (!model) {
    return null;
  }

  // Determine if this node can be duplicated
  const canDuplicate = node.type !== "start" && duplicateNode && canEdit;

  const nodePanel = (
    <model.InspectorPanel
      node={node}
      updateNode={updateNode as any}
      deleteNode={deleteNodes as any}
      //   intents={intents}
      canEdit={canEdit}
      duplicateNode={duplicateNode}
      canDuplicate={canDuplicate}

      //   {...this.props}

      //   replaceVariableNameInString={this.replaceVariableNameInString}
      //   unsetAuxPanel={this.unsetAuxPanel}
      //   hideAuxilaryPanel={this.hideAuxilaryPanel}
      //   showAuxilaryPanel={this.showAuxilaryPanel}

      //   navigationData={this.props.navigationData}
    />
  );

  return <div className={filterClasses("p-3", canEdit ? "InspectorPanel canEdit" : "InspectorPanel canNotEdit")}>{nodePanel}</div>;
}
